// ============================================================
// ✏️  EDIT THIS FILE WITH YOUR REAL INFO
// All portfolio content lives here — one place to update everything.
// ============================================================

export const ME = {
  name: "Aman Singhal",
  title: "Database Engineer",
  location: "Tokyo, Japan · Open to Remote",
  available: true,
  tagline: "I architect systems that scale to millions.",
  summary:
    "Backend-focused Software Engineer with 6+ years of experience designing and operating distributed systems using Python and Django. Strong background in building high-throughput REST APIs, database architecture, and cloud-native infrastructure on AWS. Currently contributing to DBaaS platform engineering at Rakuten, with focus on automation, scalability, and reliability of database systems.",
  email: "amansinghal.it1@gmail.com",
  github: "https://github.com/AS-AmanSinghal",
  linkedin: "https://www.linkedin.com/in/amansinghal050",
  resumeUrl: "https://drive.google.com/file/d/1jvcKQMoHMXWH1M0Tq47mvn4sLp1AJJPJ/view?usp=sharing",

  highlights: [
    "6+ yrs | Backend & Distributed Systems",
    "500M+ req/day | High-scale system design",
    "Team Lead | Platform & Infrastructure (6–8 engineers)"
  ],

  techStack: {
    Languages: ["Python", "Django", "Django Rest Framework"],
    Databases: ["Cassandra","MySQL", "DynamoDB"],
    Infrastructure: ["AWS (EC2, S3, ECS, ECR, RDS, Lambda, SQS, API Gateway, CloudWatch, Cloudformation)", "Docker"],
    Architecture: ["REST APIs", "GraphQL", "Distributed Systems", "Scalability", "Load Balancing"],
    Observability: ["Prometheus", "Grafana", "PagerDuty", "Kibana"],
    Practices: ["CI/CD (Jenkins, AWS CodePipeline, Octopus)", "Load testing", "SRE on-call"],
  },

  experience: [
    {
      company: "Rakuten Group Inc.",
      role: "Database Engineer",
      period: "2024 – Present",
      type: "Contract",
      location: "Tokyo, Japan",
      desc: "Built and operated an automated Cassandra Database-as-a-Service (DBaaS) platform managing 100+ clusters at scale. Developed Chef-driven automation for end-to-end cluster lifecycle, improving reliability and reducing manual operations.",
      impact: [
        "Built and scaled a Cassandra DBaaS platform supporting 100+ production clusters",
        "Automated lifecycle management using Chef, driving consistency, reliability, and operational efficiency",
        "Reduced human intervention and deployment risk via standardized infrastructure workflows",
        "Optimized performance and stability of distributed database systems in customer environments",
      ],
      stack: ["Cassandra", "Chef", "Jenkins", "Python", "Storage Service (S3)"],
    },
    {
      company: "Ksolves India Limited",
      role: "Software Engineer",
      period: "2020 – 2024",
      type: "Full-time",
      location: "Noida, India",
      desc: "Developed scalable backend services using Python and Django, powering production-grade web applications and APIs. Built and operated cloud-native systems on AWS with a strong focus on performance, observability, and reliability.",
      impact: [
        "Engineered scalable backend systems and RESTful services using Python and Django",
        "Designed cloud-native architectures leveraging AWS (EC2, S3, API Gateway) for production workloads",
        "Implemented observability frameworks using CloudWatch and CloudTrail to improve system visibility and reliability",
        "Contributed to end-to-end delivery of production systems in collaboration with cross-functional teams",
      ],
      stack: ["Python", "Django", "AWS Services", "Django Rest Framework"],
    },
  ],

  projects: [
    {
      title: "Automated Cassandra Database Provisioning & Management Platform",
      desc: "Designed and built a scalable Cassandra Database-as-a-Service (DBaaS) platform to automate provisioning and management of 100+ production clusters. The platform enables standardized, self-service database operations while ensuring reliability and operational efficiency at scale.",
      tags: ["Python", "Cassandra", "Chef", "AWS", "Distributed Systems", "Infrastructure Automation"],
      // github: "#",
      // live: "#",
      // metrics: "⭐ 3.8k GitHub stars · 100k tasks/sec",
      featured: true,
      icon: "",
    },
    {
      title: "Customer Relationship Management (CRM) System",
      desc: "Engineered a full-stack CRM system for dental clinic management, supporting patient records, appointment scheduling, invoicing, prescriptions, and inventory management. Implemented AI-powered modules for X-ray analysis (IOPG/OPG) and automated clinic notes generation, enhancing clinical decision-making and operational efficiency.",
      tags: ["Python", "Django", "Django Rest Framework", "AWS", "MySQL"],
      // github: "#",
      live: "https://pro.epikdoc.ai",
      // metrics: "⭐ 1.9k GitHub stars · Production at 3 companies",
      featured: true,
      icon: "",
    },
    {
      title: "Inventory Management System",
      desc: "Engineered a serverless backend system using Python and AWS Lambda, supporting high-throughput APIs processing 100K+ requests. Architected inventory workflows such as barcode-based tracking, auditing, and reporting, with AWS services (S3, CloudWatch) ensuring scalability, observability, and operational efficiency.",
      tags: ["Python", "AWS", "MySQL", "Octopus"],
      // github: "#",
      live: "https://omnicounts.com",
      // metrics: "Sub-second queries · 10B+ events ingested",
      featured: true,
      icon: "",
    }
  ],

  education: {
    degree: "Computer Science & Engineering",
    school: "GLA University, India",
    year: "2021",
  },

  certifications: [
    // "AWS Certified Solutions Architect – Professional",
    // "Certified Kubernetes Administrator (CKA)",
    // "HashiCorp Certified Terraform Associate",
  ],

  byTheNumbers: [
    { n: 6, suffix: "+", label: "Years Experience" },
    { n: 50, suffix: "M+", label: "Daily Requests Served" },
    { n: 2, suffix: "", label: "Companies (Series B → Public)" },
  ],
  recommendations: [
    {
      name: "Julie Largent",
      role: "Head of Product",
      company: "OmniCounts",
      avatar: "JL",
      relation: "Client",
      linkedin: "https://www.linkedin.com/in/juliemlargent",
      text: "I had the opportunity to work closely with Aman for over 2 years, and I can confidently say that he brought a unique combination of skills and dedication to every project. Aman demonstrated a good understanding of Python development, consistently delivering quality solutions. His knowledge of AWS services and SQL was solid, allowing him to manage backend systems effectively.\n" +
          "One of Aman's standout qualities was his strong work ethic. Aman approached each task with a high level of professionalism, ensuring that deployments were well-managed and bugs were resolved quickly.\n" +
          "He was also reliable in troubleshooting and problem-solving, always working to keep projects on track.\n" +
          "His expertise in the software development life cycle (SDLC) was commendable, and he demonstrated a clear understanding of how to move projects forward efficiently. Aman consistently produced high-quality work that added value to our team and would be a strong addition to any development team.",
    },
    {
      name: "Ryan Dammrose",
      role: "Architect",
      company: "OmniCounts",
      avatar: "RD",
      relation: "Client",
      linkedin: "https://www.linkedin.com/in/ryandammrose",
      text: "Aman has a strong grasp of Python and backend AWS technologies, such as API Gateway, Lambda, Cognito, Docker and ECS. He is easy to communicate with, writes quality code, and pays attention to a greater scope than his current task so as not to miss the forest for the trees. He is friendly and a joy to work with.",
    }
  ]
};

export const NAV_SECTIONS = ["Home", "About", "Experience", "Projects", "Stack","Recommendations", "Contact"];